import React, { PureComponent } from 'react';
import { Button, Form, Input, InputNumber, Switch } from 'antd';
import { FormItemLayout, ConfigFormDecorator, ColorPicker } from '../../tools';
import { UploadImg } from './ImageUpload';
import { JumpLink } from './JumpLink';
import { UploadFile } from '@comall-backend-builder/components-basis';
import './index.less';

const FormItem = Form.Item;

/**
 * 图文组件-配置表单
 */

const templates = [
    {
        id: '1',
        name: '常规设置',
    },
    {
        id: '2',
        name: '高级设置',
    },
];

class AdPlayerCom extends PureComponent<any> {
    state = {
        configType: '1',
    };

    handleClickTemplates = (id: string) => {
        const { onChange } = this.props;
        this.setState(
            {
                configType: id,
            },
            () => onChange({ configType: id })
        );
    };

    handleChangeItem = (path: any, filed: string) => {
        const { onChange, form } = this.props;
        const formValue = form.getFieldsValue();
        onChange({ ...formValue, [filed]: path });
    };

    render() {
        const {
            form: { getFieldDecorator },
            value: { commodityPicture, buyItPicture, jumpUrl },
            linkTypes,
            linkTypeMode,
        } = this.props;
        const { configType } = this.state;

        const formItemLayout = FormItemLayout;
        return (
            <Form className="landscape-image-box">
                <FormItem {...formItemLayout} label="配置规则">
                    {[
                        getFieldDecorator('configType', {}),
                        templates.map((item) => (
                            <Button
                                type={this.state.configType === item.id ? 'primary' : 'default'}
                                shape="round"
                                style={{ marginRight: '16px' }}
                                key={item.id}
                                onClick={() => this.handleClickTemplates(item.id)}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>

                {configType === '1' ? (
                    <div>
                        <FormItem {...formItemLayout} label="商品图片">
                            {[
                                getFieldDecorator('commodityPicture'),
                                <UploadImg
                                    {...this.props}
                                    value={commodityPicture}
                                    tip={'建议尺寸:260x260'}
                                    onChange={(path) =>
                                        this.handleChangeItem(path, 'commodityPicture')
                                    }
                                />,
                            ]}
                        </FormItem>

                        <FormItem {...formItemLayout} label="跳转链接">
                            {[
                                getFieldDecorator('jumpUrl'),
                                <JumpLink
                                    {...this.props}
                                    value={jumpUrl}
                                    linkTypes={linkTypes}
                                    linkTypeMode={linkTypeMode}
                                    onChange={(path: any) => this.handleChangeItem(path, 'jumpUrl')}
                                />,
                            ]}
                        </FormItem>

                        <FormItem {...formItemLayout} label="上传视频">
                            {getFieldDecorator('videoUrl', {
                                rules: [{ required: true, message: '视频为必填项' }],
                            })(
                                <UploadFile
                                    maxCount={1}
                                    fileName={'file_name'}
                                    uploadType={'single'}
                                    multiple={true}
                                    sortable={true}
                                    name={'videoUrl'}
                                    accept="video/mp4"
                                    uploadUrl={`${ENV.API_ROOT}/video`}
                                    mode={'default'}
                                    maxSize={100000}
                                    uploadLimitSizeErrorMessage={
                                        '视频{{ file.name }}超出限制，单个文件不能超过100MB,推荐分辨率720p'
                                    }
                                ></UploadFile>
                            )}
                            <div>支持格式：.mp4，单个文件不能超过100MB,推荐分辨率720p</div>
                        </FormItem>

                        <FormItem {...formItemLayout} label="自定义文字1">
                            {getFieldDecorator('textOne')(<Input placeholder="请输入" />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="自定义文字2">
                            {getFieldDecorator('textTwo')(<Input placeholder="请输入" />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="自定义文字3">
                            {getFieldDecorator('textThree')(<Input placeholder="请输入" />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="购买按钮图片">
                            {[
                                getFieldDecorator('buyItPicture'),
                                <UploadImg
                                    {...this.props}
                                    value={buyItPicture}
                                    tip={'建议尺寸:建议尺寸:194x38'}
                                    onChange={(path) => this.handleChangeItem(path, 'buyItPicture')}
                                />,
                            ]}
                        </FormItem>
                    </div>
                ) : (
                    <div className="senior-content">
                        <div className="senior-box">
                            <div className="senior-label">背景设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="文字颜色">
                                    {getFieldDecorator('bgColor')(
                                        <ColorPicker defaultColor="#ffffff" />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="背景高度">
                                    {getFieldDecorator('bgHeight')(
                                        <InputNumber max={5000} min={0} />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="页面边距">
                                    {getFieldDecorator('bgMargin')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="背景圆角">
                                    {getFieldDecorator('bgRadius')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                        <div className="senior-box">
                            <div className="senior-label">视频设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="是否默认静音">
                                    {getFieldDecorator('videoMute', { valuePropName: 'checked' })(
                                        <Switch />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="视频自动播放">
                                    {getFieldDecorator('videoAutoplay', {
                                        valuePropName: 'checked',
                                    })(<Switch />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="上边距">
                                    {getFieldDecorator('videoMargin')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                        <div className="senior-box">
                            <div className="senior-label">商品图设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="左边距">
                                    {getFieldDecorator('commodityLeft')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="上边距">
                                    {getFieldDecorator('commodityTop')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                        <div className="senior-box">
                            <div className="senior-label">购买图片设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="购买图片显示">
                                    {getFieldDecorator('purchaseShow', {
                                        valuePropName: 'checked',
                                    })(<Switch />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="左边距">
                                    {getFieldDecorator('purchaseLeft')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="上边距">
                                    {getFieldDecorator('purchaseTop')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                        <div className="senior-box">
                            <div className="senior-label">文字1设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="字体大小">
                                    {getFieldDecorator('textOneSize')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="字体颜色">
                                    {getFieldDecorator('textOneColor')(
                                        <ColorPicker defaultColor="#323233" />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="左边距">
                                    {getFieldDecorator('textOneLeft')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="上边距">
                                    {getFieldDecorator('textOneTop')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                        <div className="senior-box">
                            <div className="senior-label">文字2设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="字体大小">
                                    {getFieldDecorator('textTwoSize')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="字体颜色">
                                    {getFieldDecorator('textTwoColor')(
                                        <ColorPicker defaultColor="#323233" />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="左边距">
                                    {getFieldDecorator('textTwoLeft')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="上边距">
                                    {getFieldDecorator('textTwoTop')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                        <div className="senior-box">
                            <div className="senior-label">文字3设置：</div>
                            <div className="senior-constnt">
                                <FormItem {...formItemLayout} label="字体大小">
                                    {getFieldDecorator('textThreeSize')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="字体颜色">
                                    {getFieldDecorator('textThreeColor')(
                                        <ColorPicker defaultColor="#323233" />
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="左边距">
                                    {getFieldDecorator('textThreeLeft')(<InputNumber min={0} />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="上边距">
                                    {getFieldDecorator('textThreeTop')(<InputNumber min={0} />)}
                                </FormItem>
                            </div>
                        </div>
                    </div>
                )}
            </Form>
        );
    }
}

export const AdPlayer = ConfigFormDecorator(AdPlayerCom);
